/**
 * CopyButton — botón "copiar al portapapeles" con feedback efímero (✓ 1.5s).
 * B5 — usado en la barra de acciones de cada mensaje del asistente y en los
 * bloques de código del markdown. Sin estado en el padre: encapsula el suyo.
 */

import { useState } from 'react';
import PropTypes from 'prop-types';
import { Copy, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function CopyButton({ text, label = 'Copiar', className = 'h-5 w-5' }) {
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(text ?? '');
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard no disponible (http o permisos) — no romper la UI */
    }
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      aria-label={copied ? 'Copiado' : label}
      title={copied ? 'Copiado' : label}
      onClick={onCopy}
      className={className}
    >
      {copied
        ? <Check className="h-3 w-3 text-success" />
        : <Copy className="h-3 w-3 text-muted-foreground" />}
    </Button>
  );
}

CopyButton.propTypes = {
  text: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
};
